import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { createContext, useEffect, useState } from "react";
import { matchPath } from "react-router";
import { withRouter } from "react-router-dom";
import { compareTwoStrings } from "string-similarity";
export var RouterHistoryContext = createContext({
  routes: []
});

var RouterHistoryComponent = function RouterHistoryComponent(a) {
  var b = a.routes,
      c = a.children,
      d = a.location,
      e = _objectWithoutProperties(a, ["routes", "children", "location"]),
      f = b.find(function (a) {
    return matchPath(d.pathname, {
      path: a.path
    });
  }) || {},
      g = f.name;

  d.name = g, d.path = "".concat(d.pathname).concat(d.search);

  var h = useState({
    old: null,
    current: d
  }),
      i = _slicedToArray(h, 2),
      j = i[0],
      k = i[1],
      l = j.current;

  return useEffect(function () {
    if (l.pathname !== d.pathname || l.search !== d.search) {
      var a = compareTwoStrings(l.pathname, d.pathname);
      .94 > a && k({
        old: l,
        current: d
      });
    }
  }, [l, d]), /*#__PURE__*/React.createElement(RouterHistoryContext.Provider, {
    value: j
  }, c);
};

export var RouterHistory = withRouter(RouterHistoryComponent);
export default RouterHistory;